module.exports = __webpack_public_path__ + "img/Splashscreen_focus.00c84605.jpg";